module.exports = __webpack_public_path__ + "fonts/RobotoCondensed-Bold.2acad7b.ttf";